export class BaseAuthenticator {
    constructor(type) {
        this._valid = true;
        this._authenticating = false;
        this._tried = false;
        this._result = new Promise((resolve) => {
            this._resolve = resolve;
        });
        this.type = type;
    }
    isValid() {
        return this._valid;
    }
    invalidate() {
        this._valid = false;
    }
    authenticate() {
        return this._result;
    }
    isAuthenticating() {
        return this._authenticating;
    }
    authenticated() {
        return this._result;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
    applyHeaders(headers) {
        // Do nothing
    }
}
//# sourceMappingURL=base-authenticator.js.map